import {createSlice} from '@reduxjs/toolkit';
import {apiAdmin} from '../../managers/api-manager';

export type IspLogoutSlicerState = {};

const initialState: IspLogoutSlicerState = {};

const logout = apiAdmin.logout();

export const apiIspLogoutSlice = createSlice({
  name: 'api-isp-logout',
  initialState,
  reducers: {},
});

export const apiIspLogoutAction = apiIspLogoutSlice.actions;
export const apiIspLogoutReducer = apiIspLogoutSlice.reducer;
